"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EquipmentArgs = exports.EquipmentArgsAttribute = void 0;
class EquipmentArgsAttribute {
    constructor(attribute, amount) {
        this.attribute = attribute;
        this.amount = amount;
    }
}
exports.EquipmentArgsAttribute = EquipmentArgsAttribute;
class EquipmentArgs {
    constructor(equipIn, item) {
        this.equipIn = equipIn;
        this.item = item;
    }
}
exports.EquipmentArgs = EquipmentArgs;
